import httpRequest from '@/request/index'

export const ApiAuth = {
    apiGetUserAuth: () => {
        return httpRequest.request({
            url: `/api/zba/user/auth`,
            method: "GET",
          });
    },
    // 获取用户角色信息
    apiGetUserRoles: (headers) => {
        return httpRequest.request({
            url: `api/zba/user/roles`,
            method: "GET",
            headers

          });
    },
   
}